// extracted by mini-css-extract-plugin
module.exports = {"rainbow":"Stake_rainbow__ZZkIq","card":"Stake_card__DXSDD","cardRainbow":"Stake_cardRainbow__yAnT_","cardPink":"Stake_cardPink___d2V9"};